import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  applicationMergeMutationArgs,
  ApplicationMergeMutationArgs
} from '../types/application-merge-mutation-args'
import {
  applicationFilterMergeMutationArgs,
  ApplicationFilterMergeMutationArgs
} from '../types/application-filter-merge-mutation-args'
import { mapApplicationFilters } from '../endpoint-helpers'

export const mergeApplications: GraphQLFieldConfig<
  any,
  Context,
  ApplicationMergeMutationArgs
> = {
  description: 'Merge applications',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: applicationMergeMutationArgs,
  resolve: async function resolve(
    _source,
    args,
    context
  ): Promise<GenericMutationResponse> {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { ids, organizationID, primaryID } = input

    const { connector } = context

    await connector.put(`/${organizationID}/modules/${primaryID}/merge`, {
      apps: ids
    })

    return { _placeholder: true }
  }
}

export const mergeApplicationsByFilters: GraphQLFieldConfig<
  any,
  Context,
  ApplicationFilterMergeMutationArgs
> = {
  description: 'Merge applications by filters',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: applicationFilterMergeMutationArgs,
  resolve: async function resolve(
    _source,
    args,
    context
  ): Promise<GenericMutationResponse> {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { excludedApplications, filters, organizationID, primaryID } = input

    const { connector } = context

    await connector.put(
      `/${organizationID}/applications/bulk/${primaryID}/merge`,
      {
        ...mapApplicationFilters(filters),
        excludedApplications
      }
    )

    return { _placeholder: true }
  }
}
